import {
    GET_CASE_DETAILS_REQUEST,
    GET_CASE_DETAILS_SUCCESS,
    GET_CASE_DETAILS_FAILURE,
    GET_AVAILABLE_UNITS_REQUEST,
    GET_AVAILABLE_UNITS_SUCCESS,
    GET_AVAILABLE_UNITS_FAILURE,
    EDIT_CASE_DETAILS_SUCCESS,
    EDIT_CASE_DETAILS_FAILURE,
    CANCEL_CASE_REQUEST,
    CANCEL_CASE_SUCCESS,
    CANCEL_CASE_FAILURE,
    CONVERT_CASE_SUCCESS,
    CONVERT_CASE_FAILURE,
    CONVERT_CASE_REQUEST,
    EDIT_CASE_DETAILS_REQUEST,
    EDIT_ADMIN_CASE_NOTES_SUCCESS,
    CHANGE_CASE_STATUS_REQUEST,
    CHANGE_CASE_STATUS_SUCCESS,
    CHANGE_CASE_STATUS_FAILURE,
} from './constants';

const initialState = {
    caseList: [],
    caseFaller: undefined,
    edited: undefined,
    editFailer: undefined,
    loading: false,
    cancelCase: false,
    availableUnits: undefined,
    dateOfReturn: undefined,
    myUnits: undefined,
    getCasesSuccess: undefined,
    converted: false,
    editingDataLoading: false,
    btnShow: true,
    subcaseAvailableUnitsLoading: false,
    isStatusChanging: false
};

const adminCaseDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CASE_DETAILS_REQUEST: {
            return Object.assign({}, state, {loading: true, getCasesSuccess: undefined,  cancelCase: false, caseFaller: false, edited: undefined, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined});
        }
        case GET_CASE_DETAILS_SUCCESS: {
            return Object.assign({}, state, {loading: false, getCasesSuccess: true, cancelCase: false, caseFaller: false, edited: undefined, caseList: action.data, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined,});
        }
        case GET_CASE_DETAILS_FAILURE: {
            return Object.assign({}, state, {loading: false, getCasesSuccess: false, cancelCase: false, caseFaller: true, edited: undefined, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined});
        }
        case GET_AVAILABLE_UNITS_REQUEST: {
            return Object.assign({}, state, {subcaseAvailableUnitsLoading: true, loading: false, getCasesSuccess: undefined, cancelCase: false, caseFaller: false, edited: undefined, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined});
        }
        case GET_AVAILABLE_UNITS_SUCCESS: {
            return Object.assign({}, state, {subcaseAvailableUnitsLoading: false, loading: false, getCasesSuccess: undefined, cancelCase: false, caseFaller: false, edited: undefined, availableUnits: action.data.availableUnits, dateOfReturn: action.data.date, myUnits: action.data.myUnits});
        }
        case GET_AVAILABLE_UNITS_FAILURE: {
            return Object.assign({}, state, {subcaseAvailableUnitsLoading: false, loading: false, getCasesSuccess: undefined, cancelCase: false, caseFaller: false, edited: undefined, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined});
        }
        case EDIT_CASE_DETAILS_REQUEST: {
            return Object.assign({}, state, {loading: false, editingDataLoading: true, getCasesSuccess: undefined, cancelCase: false, caseFaller: false, edited: undefined, editFailer: false , caseList: action.data, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined});
        }
        case EDIT_CASE_DETAILS_SUCCESS: {
            return Object.assign({}, state, {loading: false, editingDataLoading: false, getCasesSuccess: undefined, cancelCase: false, caseFaller: false, edited: true, editFailer: false , caseList: action.data, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined});
        }
        case EDIT_CASE_DETAILS_FAILURE: {
            return Object.assign({}, state, {loading: false, editingDataLoading: false, getCasesSuccess: undefined, cancelCase: false, caseFaller: false, edited: false, editFailer: true, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined});
        }
        case CONVERT_CASE_REQUEST: {
            return Object.assign({}, state, {loading: false, getCasesSuccess: undefined, cancelCase: false, caseFaller: false, edited: false, converted: false, editFailer: false , caseList: action.data, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined});
        }
        case CONVERT_CASE_SUCCESS: {
            return Object.assign({}, state, {loading: false, getCasesSuccess: undefined, cancelCase: false, caseFaller: false, edited: false, converted: true, editFailer: false , caseList: action.data, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined});
        }
        case CONVERT_CASE_FAILURE: {
            return Object.assign({}, state, {loading: false, getCasesSuccess: undefined, cancelCase: false, caseFaller: true, edited: false, converted: false, editFailer: true, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined});
        }
        case CANCEL_CASE_REQUEST: {
            return Object.assign({}, state, {cancelCase: null});
        }
        case CANCEL_CASE_SUCCESS: {
            return Object.assign({}, state, {cancelCase: true});
        }
        case CANCEL_CASE_FAILURE: {
            return Object.assign({}, state, {cancelCase: false});
        }
        case EDIT_ADMIN_CASE_NOTES_SUCCESS: {
            return Object.assign({}, state, {btnShow: !state.btnShow, loading: false, getCasesSuccess: undefined, cancelCase: false, caseFaller: false, edited: false, converted: false,  editFailer: false , availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined});
        }
        case CHANGE_CASE_STATUS_REQUEST: {
            return Object.assign({}, state, {loading: true, getCasesSuccess: undefined, cancelCase: false, caseFaller: false, edited: false, converted: true, editFailer: false , caseList: action.data, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined, isStatusChanging: true});
        }
        case CHANGE_CASE_STATUS_SUCCESS: {
            return Object.assign({}, state, {loading: false, getCasesSuccess: true, cancelCase: false, caseFaller: false, edited: false, converted: true, editFailer: false , caseList: action.data.data, availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined, isStatusChanging: false});
        }
        case CHANGE_CASE_STATUS_FAILURE: {
            return Object.assign({}, state, {loading: false, getCasesSuccess: false, cancelCase: false, caseFaller: false, edited: false, converted: true, editFailer: false , availableUnits: undefined, dateOfReturn: undefined, myUnits: undefined, isStatusChanging: false});
        }

        default: {
            return state;
        }
    }
};

export default adminCaseDetailsReducer;



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AdminCaseDetails/reducer.js